import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { SbSelectBase, sbSelectProviders } from './sb-select-base.component';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { InfoPopoverComponent } from '../../info-popover/info-popover.component';

@Component({
  selector: 'app-sb-input-select',
  templateUrl: './sb-select.component.html',
  styleUrls: ['./sb-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: sbSelectProviders(() => SbInputSelectComponent),
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgSelectComponent, NgLabelTemplateDirective, NgOptionTemplateDirective, ReactiveFormsModule, FormsModule, InfoPopoverComponent]
})
export class SbInputSelectComponent extends SbSelectBase implements OnInit {
  constructor() {
    super();
    this.mode.set('default');
  }

  ngOnInit(): void {
    this.mode.set('default');
    this.resolveItems();
  }
}

/** @deprecated Use SbInputSelectComponent */
export { SbInputSelectComponent as SbSelectComponent };
